// This is a modal for Adminvendorstwo

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { updateReferralsItems } from "./redux/slices/ReferralsThunks";

export default function ModalAdminreferralstatus({
  onClose,
  data,
  setData,
  setOldData,
  oldData,
  type,
}) {
  const dispatch = useDispatch();
  const option =
    type == "Member"
      ? [
          { value: "Tracking", label: "Tracking" },
          { value: "Successful", label: "Successful" },
          { value: "Unsuccessful", label: "Unsuccessful" },
          { value: "Paid", label: "Paid" },
        ]
      : [
          { value: "Lead Identified", label: "Lead Identified" },
          { value: "Opportunity", label: "Opportunity" },
          { value: "Proposal Sent", label: "Proposal Sent" },
          { value: "Verbally Committed", label: "Verbally Committed" },
          { value: "Lost", label: "Lost" },
          { value: "Won", label: "Won" },
        ];

  console.log(data);

  const handler = async () => {
    try {
      const date = Date.now();
      const bodyData = {
        _id: data._id,
        referral_member_status: data.referral_member_status,
        referral_status: data.referral_status,
        referral_lost_reason: data.referral_lost_reason,
      };
      const res = await dispatch(updateReferralsItems(bodyData));
      setOldData(data);
      onClose();
    } catch (e) {
      console.log(e, "error");
    }
  };

  return (
    <RootWrapperModalAdminvendorstwo>
      <Wrapper>
        <Sector>
          <Left>
            <Frame58>
              <Frame1391>
                <Tag>Status</Tag>
                <SubText>
                  Please update the status of this referral based on current
                  information.
                </SubText>
              </Frame1391>
              <Frame1391>
                <PRTNR.Select
                  label="Select Status"
                  options={option}
                  value={
                    type == "Member"
                      ? data?.referral_member_status
                      : data?.referral_status
                  }
                  onChange={(e) => {
                    type == "Member"
                      ? setData({
                          ...data,
                          referral_member_status: e.target.value,
                        })
                      : setData({ ...data, referral_status: e.target.value });
                  }}
                />
                {type != "Member" && data?.referral_status == "Lost" && (
                  <PRTNR.TextArea
                    label={"Notes"}
                    rows={8}
                    value={data?.referral_lost_reason}
                    onChange={(e) => {
                      setData({
                        ...data,
                        referral_lost_reason: e.target.value,
                      });
                    }}
                  />
                )}
              </Frame1391>
              <Frame59>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    setData(oldData);
                    onClose();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Cancel
                  </span>
                </AIMEButton>

                <AIMEButton
                  size="small"
                  onClick={() => {
                    handler();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    width: "240px",
                    background: "rgb(97, 98, 197)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Update
                  </span>
                </AIMEButton>
              </Frame59>
            </Frame58>
          </Left>
        </Sector>
      </Wrapper>
    </RootWrapperModalAdminvendorstwo>
  );
}

const RootWrapperModalAdminvendorstwo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  border-radius: 32px;
  width: 550px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const Sector = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 486px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 486px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Tag = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;


const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const SubText = styled.span`
  color: rgba(33, 37, 67, 1);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 140%;
  text-align: left;
`;
